module.exports = __webpack_public_path__ + "static/media/3_7.e0407a07.png";